export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED === "true";
export const SENTRY_MODE = import.meta.env.VITE_SENTRY_ENVIRONMENT;

export const IS_SENTRY_ENABLED = Boolean(SENTRY_DSN && SENTRY_ENABLED);

export const DATADOG_APPLICATION_ID = import.meta.env.VITE_DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;
export const DATADOG_SITE = import.meta.env.VITE_DATADOG_SITE || "datadoghq.com";
export const DATADOG_SERVICE = import.meta.env.VITE_DATADOG_SERVICE || "opik-frontend";
export const DATADOG_ENABLED = import.meta.env.VITE_DATADOG_ENABLED === "true";
export const DATADOG_ENV = import.meta.env.VITE_DATADOG_ENV || import.meta.env.MODE;

export const IS_DATADOG_ENABLED = Boolean(DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN && DATADOG_ENABLED);
